import React from 'react';
import { Button } from '../../../../components/Button';
import { StepEndButtonsProps } from '../../utils/Type';
import styles from './style.module.css';

export const Buttons = ({
  isSubmitting,
  config,
  render = true,
  typeSecondButton = 'button',
}: StepEndButtonsProps) => {
  const { firstClick, secondClick, firstText, secondText, edit } = config;
  if (!render) {
    return null;
  }
  return (
    <div className="tc items-center pt24 pt32-m pt32-l pb16 pb24-ns db flex-ns">
      <div className={styles.nextButton}>
        <Button
          type={edit ? 'button' : 'submit'}
          loading={isSubmitting}
          classButton="w-100"
          onClick={firstClick}
          aria-label={`Botao ${firstText}`}
        >
          {firstText}
        </Button>
      </div>
      <div className="mt32 mb24 mt0-ns mb0-ns ml32-ns">
        <button
          type={typeSecondButton}
          className="red underline f14 fw6 bg-transparent bn db di-ns center flex justify-center ttu"
          onClick={secondClick}
          aria-label={`Botao ${secondText}`}
        >
          {secondText}
        </button>
      </div>
    </div>
  );
};
